/*
 * @Author: Phoenix
 * @Date: 2020-02-18 13:51:58
 * @LastEditTime: 2021-01-13 10:14:56
 * @Description:
 * @FilePath: /ups-single-window-web/src/request/index.js
 * @未经本人许可，任何单位及个人不得以任何方式对本产品进行使用、复制、修改、抄录、传播或与其它产品捆绑使用、销售。
 */
import axios from 'axios'
import store from '@/store'
import router from '@/router'
// import { ElLoading } from 'element-plus'
import { showLoading, hideLoading } from '@/element-ui/loading'
import { ElMessage } from 'element-plus'
import ErrorCode from './error-code'
import { decodeChar, replaceAll, funcUrlDel, encodeChar } from './decodeChar'
import specialHandlingErrMsg from './specialHandlingErrMsg'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 1200000 // request timeout
})

// 全局loading实例
// const globalLoadingInstance = ElLoading.service({
//   lock: true,
//   text: 'Loading',
//   background: 'rgba(0, 0, 0, 0.7)'
// })
let globalRequestList = []
let loadingCount = 0
let loadingShown = false

function singleRequestFinished(url) {
  const currentRequest = globalRequestList.find(v => {
    if (!process.env.VUE_APP_BASE_API) {
      return url === v.url && !v.finished
    }
    // console.log('url.split(process.env.VUE_APP_BASE_API): ', url.split(process.env.VUE_APP_BASE_API))
    return url.split(process.env.VUE_APP_BASE_API)[1] === v.url && !v.finished
  })
  // console.log('process.env.VUE_APP_BASE_API: ', process.env.VUE_APP_BASE_API)
  // console.log('singleRequestFinished: ', url, globalRequestList)
  // console.log('currentRequest: ', currentRequest)
  // console.log('globalRequestList: ', globalRequestList)
  currentRequest && (currentRequest.finished = true)
  const isAllRequestFinished = globalRequestList.every(v => v.finished)
  if (isAllRequestFinished) {
    // globalLoadingInstance && globalLoadingInstance.close()
    globalRequestList = []
  }
}

function showLoadingIfNeeded(config) {
  // 根据config.hiddenLoading判断是否需要显示loading
  if (!config.hiddenLoading && !loadingShown) {
    showLoading()
    loadingShown = true
  }
  if (!config.hiddenLoading) {
    loadingCount++
  }
}

function hideLoadingIfNeeded(config) {
  if (!config.hiddenLoading) {
    loadingCount--
    // 只有当所有需要loading的请求都完成时，才隐藏loading
    if (loadingCount <= 0 && loadingShown) {
      hideLoading()
      loadingShown = false
      loadingCount = 0
    }
  }
}
// request interceptor
service.interceptors.request.use(config => {
  // 默认展示loading
  config.url = funcUrlDel(config.url)
  showLoadingIfNeeded(config)
  if (!config.hiddenLoading) {
    // globalLoadingInstance.open()
    globalRequestList.push({ url: config.url, finished: false })
  }
  if (store.getters.token) {
    config.headers['Authorization'] = store.getters.token
  }
  // url添加encodeUrl
  if (config.method.toLocaleLowerCase() === 'post' || config.method.toLocaleLowerCase() === 'put') {
    if (config.data && config.headers.ContentType !== 'multipart/form-data') {
      config.data = JSON.parse(JSON.stringify(config.data))
    }
    if (config.params) {
      config.params = JSON.parse(JSON.stringify(config.params))
      encodeChar(config.params)
    }
    encodeChar(config.data)
  }
  if (config.method.toLocaleLowerCase() === 'get' && config.params) {
    config.params = JSON.parse(JSON.stringify(config.params))
    encodeChar(config.params)
  }

  // delete 请求需要encodeUrl
  if (config.method.toLocaleLowerCase() === 'delete' && config.params) {
    config.params = JSON.parse(JSON.stringify(config.params))
    encodeChar(config.params)
  }
  return config
}, error => {
  return Promise.reject(error)
})

// response interceptor
service.interceptors.response.use(response => {
  const res = response.data

  singleRequestFinished(response.config.url)

  // refresh token
  if (res.refreshed) {
    store.commit('user/SET_TOKEN', res.accessToken)
  }
  // need reloagin
  if (res.code === ErrorCode.ErrRequestNeedRelogin) {
    ElMessage({ message: res.message, iconClass: 'el-icon-warning-outline', grouping: true })
    store.dispatch('user/LOGOUT').then(() => {
      location.reload()
    })
    hideLoadingIfNeeded(response.config)
    return Promise.reject(new Error(res.message || 'Error'))
  // } else if (res.code === ErrorCode.ErrRequestForbidden) {
  } else if (res.code === -1) {
    // 403无法访问
    router.replace('/401')
    hideLoadingIfNeeded(response.config)
    return Promise.reject(new Error(res.message || 'Error'))
  } else if (res.code === ErrorCode.ErrRequestException) {
    // 清关有个单独code 20000
    res.message = replaceAll(res.message)
    hideLoadingIfNeeded(response.config)
    return res
  } else if (res.code !== ErrorCode.ErrRequestSuccess) {
    if (!response.config.hideErrorMessage) {
      // 10002 首次登陆需要重设密码, 您的账号已被注销(移交主管理员之后重新登录)
      const accountLogout = res.message.includes(specialHandlingErrMsg.accountLogout)
      if (
        res.code !== ErrorCode.ErrRequestNewUser &&
        res.code !== ErrorCode.ErrRequestNeedUpdatePassword &&
        res.code !== ErrorCode.ErrRequestAccountTransfer &&
        res.code !== ErrorCode.ErrRequestPwdNotMatch &&
        res.code !== ErrorCode.ErrRequestAccountLocked &&
        !accountLogout
      ) ElMessage({ type: 'error', message: replaceAll(res.message), grouping: true })
    }
    res.message = replaceAll(res.message)
    // ElMessage({ type: 'error', message: replaceAll(res.message) })
    hideLoadingIfNeeded(response.config)
    return Promise.reject(res)
  }
  // request success
  decodeChar(res.data)
  hideLoadingIfNeeded(response.config)
  return res.data
}, error => {
  const res = error.response
  console.log('error.response: ', error.response)
  hideLoadingIfNeeded(error.config)
  if (!res) {
    // globalLoadingInstance.close()
    globalRequestList = []
    ElMessage({ message: error.message || '网络错误', type: 'error', grouping: true })
    return Promise.reject(error)
  }
  singleRequestFinished(res.config.url)
  if (res.status === 401) {
    ElMessage({ message: '您未登录或者登录已超时, 请先登录!', iconClass: 'el-icon-warning-outline', grouping: true })
    store.dispatch('user/LOGOUT').then(() => {
      location.reload()
    })
    return Promise.reject(new Error(res.data?.message || 'Error'))
  }
  if (!res.config.hideErrorMessage) {
    ElMessage({ message: error.message, type: 'error', iconClass: 'el-icon-warning-outline', grouping: true })
  }
  return Promise.reject(error)
})

export default service
